export const cardLabelToStr = (label) => {
  return Array.isArray(label) ? '' : label
}
